import { rankings } from "../../../mocks/trendData";

const trendUi: Record<string, { icon: string; cls: string; label: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "bg-primary-100 text-primary-700", label: "热度上升" },
  steady: { icon: "ri-arrow-right-line", cls: "bg-accent-100 text-accent-800", label: "热度持平" },
  down: { icon: "ri-arrow-down-line", cls: "bg-background-200 text-foreground-500", label: "热度回落" },
};

export default function Ranking() {
  return (
    <section id="hot" className="bg-background-100 py-10 md:py-14">
      <div className="container-x grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="section-kicker">热度趋势榜</span>
          <h2 className="mt-3 font-heading text-xl font-black leading-snug tracking-tight text-foreground-950 md:text-3xl">
            谁在升温，谁在回落
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            按近 24 小时讨论增量排序，帮助快速判断哪些新事件正在起势、哪些旧话题正走向收敛。
          </p>
          <a href="#feed" className="btn-ghost mt-6">
            去最新动态看看
            <i className="ri-arrow-right-line ml-1" aria-hidden="true"></i>
          </a>
        </div>

        <div className="lg:col-span-8">
          <ol className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {rankings.map((r, idx) => {
              const ui = trendUi[r.trend];
              return (
                <li
                  key={r.title}
                  className="group flex items-center gap-4 border-b border-background-100 px-4 py-3.5 transition-colors hover:bg-background-100 md:px-5"
                >
                  <span
                    className={`font-heading w-8 shrink-0 text-xl font-black md:text-2xl ${
                      idx < 3 ? "text-primary-600" : "text-foreground-300"
                    }`}
                  >
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-700 md:text-[15px]">
                      {r.title}
                    </p>
                  </div>
                  <span className="shrink-0 text-sm font-bold text-foreground-800">{r.heat}</span>
                  <span
                    className={`hidden shrink-0 items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold sm:inline-flex ${ui.cls}`}
                    title={ui.label}
                  >
                    <i className={ui.icon} aria-hidden="true"></i>
                    {r.delta}
                  </span>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}